export default __webpack_public_path__ + "static/media/stratum.b4e7d2d1.svg";